export default __webpack_public_path__ + "static/media/ic-line-chevron-left.4176be16.svg";